<template>
  <base-modal v-bind="$attrs">
    <div class="modal-content">
      <slot></slot>
    </div>
  </base-modal>
</template>

<script>
  import BaseModal from './BaseModal.vue';

  export default {
    name: 'SimpleModal',
    components: { BaseModal },
  };
</script>

<style lang="scss" scoped>
  @include tablet {
    .modal {
      flex-direction: column;
    }
  }
</style>
